// Gestion du niveau de données ciblé par l'outil de recette (1 par défaut)
const STORAGE_KEY = 'data_level';

export function getLevel() {
    const value = parseInt(localStorage.getItem(STORAGE_KEY), 10);
    return value === 2 ? 2 : 1;
}

export function setLevel(level) {
    localStorage.setItem(STORAGE_KEY, String(level === 2 ? 2 : 1));
}
